import { useIsMobile } from "@/hooks/use-mobile";
import { RootState } from "@/redux/store";
import { routes } from "@/routes/utils";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const usePropertyBulkUpload = () => {
  const navigate = useNavigate();
  const communityData = useSelector(
    (state: RootState) => state.currentData.communityData
  );
  const bulkUploadDtl = useSelector(
    (state: RootState) => state.currentData.bulkUploadDtl
  );
  const [currentStep, setCurrentStep] = useState<number>(1);
  const location = useLocation();
  // Users grid of the same persona, opened on this community
  const usersPath = `${location.pathname.split(`/${routes.bulkUpload}`)[0]}?communityId=${communityData?.communityId ?? ""}`;
  const isMobile = useIsMobile();

  const breadcrumbData = [
    {
      link: ``,
      name: `Master Data`,
    },
    {
      link: ``,
      name: `People`,
    },
    {
      link: usersPath,
      name: `Manage Users - ${communityData?.name}`,
    },
    {
      link: "",
      name: <span className="text-primary">{"Bulk Upload Users"}</span>,
    },
  ];

  const onNextStepClick = () => {
    setCurrentStep(currentStep + 1);
  };

  const onPreviousStepClick = () => {
    setCurrentStep(currentStep - 1);
  };

  const onStepperClick = (curr_step: number) => {
    setCurrentStep(curr_step);
  };

  const onBackClick = () => {
    navigate(usersPath)
  }

  const hasDuplicateRows = useMemo(() => bulkUploadDtl?.rows?.some((data: any) => data?.status?.toLowerCase() == "duplicate"), [bulkUploadDtl])

  return {
    breadcrumbData,
    isMobile,
    currentStep,
    onStepperClick,
    onNextStepClick,
    onPreviousStepClick,
    onBackClick,
    hasDuplicateRows
  }
}

export default usePropertyBulkUpload;